import React from "react";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Skeleton from "@material-ui/lab/Skeleton";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

export function PurchaseSkeletonCard() {
	return (
		<Card variant="outlined" style={{ margin: "5px 0" }}>
			<CardBody>
				<GridContainer>
					<GridItem lg={6} md={6} sm={12} xs={12}>
						<Skeleton variant="text" width="60%" height={32} />
					</GridItem>
					<GridItem
						lg={6}
						md={6}
						sm={12}
						xs={12}
						style={{
							textAlign: "right",
							verticalAlign: "bottom",
						}}
					>
						<Skeleton variant="text" width="50%" height={24} style={{ marginLeft: "auto" }} />
					</GridItem>
					<GridItem
						lg={6}
						md={6}
						sm={12}
						xs={12}
						style={{ margin: "5px 0" }}
					>
						<Skeleton variant="text" width="40%" height={24} />
					</GridItem>
					<GridItem
						lg={6}
						md={6}
						sm={12}
						xs={12}
						style={{ textAlign: "right" }}
					>
						<Skeleton variant="text" width="35%" height={24} style={{ marginLeft: "auto" }} />
					</GridItem>
					<GridItem
						lg={12}
						md={12}
						sm={12}
						xs={12}
						style={{ textAlign: "right" }}
					>
						<Skeleton variant="text" width="15%" height={20} style={{ marginLeft: "auto" }} />
					</GridItem>
				</GridContainer>
			</CardBody>
		</Card>
	);
}
